import { PROPERTIES_RECEIVED, PROPERTIES_UNLOADED, PROPERTY_SAVED, PROPERTY_DELETED } from './types'
import api from 'api'

export const propertyDataReceived = data => ({
  type: PROPERTIES_RECEIVED,
  data
})

export const propertyDataUnload = () => ({
  type: PROPERTIES_UNLOADED
})

export const propertySaved = data => ({
  type: PROPERTY_SAVED,
  data
})

export const propertyDeleted = data => ({
  type: PROPERTY_DELETED,
  data
})

export const unloadProperties = () => dispatch => {
  dispatch(propertyDataUnload())
}

export const deleteProperty = data => dispatch =>
  api.bmc.properties.deleteProperty(data).then( res => {
    dispatch(propertyDeleted(data))
  })

export const saveProperty = data => dispatch =>
  api.bmc.properties.postProperty(data).then( res => {
    dispatch(propertySaved(res))
    return res.id
  })

export const getProperties = planid => dispatch =>
  api.bmc.properties.getProperties(planid).then( data => {
    dispatch(propertyDataReceived(data))
  })
